import { formatNumber, formatPercent, formatActionType } from '../utils/format';

export default {
    methods: {
        formatNumber(value, decimals) {
            return formatNumber(value, decimals, this.$root.lang);
        },
        formatPercent(value) {
            return formatPercent(value, this.$root.lang);
        },
        formatActionType,
    },
};
